// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3rAXl","tab":"Tabs_tab__h7ItY","tabActive":"Tabs_tabActive__3sUtu"};